
import http from  './axios'
/**预约挂号 */
export const clinicSelList = param =>{return http.post("clinic-manager/registered/getHisDepartment",param).then(res=>res.data.data)};
//查询医院科室
export const forClinicList = param =>{return http.post("clinic-manager/registered/getHisDiagnosis",param).then(res=>res.data.data)};
//待诊/就诊列表
export const appointRegister  = param =>{return http.post("clinic-manager/registered/getHisRegistered",param).then(res=>res.data.data)};
//查询医院预约挂号
export const clinicDoctor  = param =>{return http.post("clinic-manager/registered/getHisUser",param).then(res=>res)};
//查询科室医生
export const patientByname  = param =>{return http.post("clinic-manager/registered/getPatientList",param).then(res=>res.data.data)};
//根据名字搜索患者列表
export const saveAppoiReg  = param =>{return http.post("clinic-manager/registered/saveHisRegistered",param).then(res=>res)};
//保存医院预约挂号
export const updAppoiReg  = param =>{return http.post("clinic-manager/registered/updHisRegisteredById",param).then(res=>res.data)};

//修改预约挂号


// WEBPACK FOOTER //
// ./src/api/appoint.js